import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import api from "@/lib/api";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/notifications")
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/mark-read`).catch(() => {});
    if (n.ref_code) nav(`/requisitions/${n.ref_code}`);
  };

  return (
    <Layout>
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-widest text-[#2d6b6b] font-semibold">Inbox</div>
        <h1 className="font-serif text-3xl font-bold text-[#1f2320]">All notifications</h1>
      </div>
      {loading ? <div className="p-8 text-center text-[#6e7770]">Loading…</div> :
       items.length === 0 ? <div className="p-8 text-center text-[#6e7770]">No notifications yet.</div> :
       <div className="sheet-plain divide-y divide-[#f2ecdf]" data-testid="notifications-list">
         {items.map((n) => (
           <button key={n.id} className={`w-full text-left px-5 py-4 hover:bg-[#faf5eb] transition-colors ${!n.read ? "bg-[#fdf9ed]" : ""}`}
                   onClick={() => open(n)} data-testid={`notification-full-${n.id}`}>
             <div className="flex items-baseline gap-2 mb-1">
               {!n.read && <span className="w-2 h-2 rounded-full bg-[#b3261e]"></span>}
               <div className="font-serif font-semibold text-[#1f2320]">{n.title}</div>
               <div className="text-xs text-[#6e7770] ml-auto">{new Date(n.created_at).toLocaleString()}</div>
             </div>
             <div className="text-sm text-[#4a524c]">{n.body}</div>
             {n.ref_code && <div className="text-xs text-[#2d6b6b] mt-1 font-mono">{n.ref_code}</div>}
           </button>
         ))}
       </div>}
    </Layout>
  );
}
